import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Typography } from '../Typography';
import styles from './Badge.module.scss';
import { skinToTypographyMap } from './Badge.utils';
export const Badge = /*#__PURE__*/ React.forwardRef(function Badge(props, ref) {
    const { children, skin = 'default', size = 'default', rounded = false, outlined = false, className, as } = props, rest = _object_without_properties(props, [
        "children",
        "skin",
        "size",
        "rounded",
        "outlined",
        "className",
        "as"
    ]);
    return /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        className: cn(styles.root, className, styles[skin], styles[size], {
            [styles.outlined]: outlined,
            [styles.rounded]: rounded
        }),
        as: as,
        variant: "paragraph2",
        skin: skinToTypographyMap[skin],
        children: children
    }));
});
